var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m320.818 236.386c29.258 0 53.061-23.804 53.061-53.063v-130.262c0-29.258-23.803-53.061-53.061-53.061-29.259 0-53.063 23.803-53.063 53.061v130.263c.001 29.258 23.805 53.062 53.063 53.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.877 236.386h38.063c29.258 0 53.061-23.804 53.061-53.063 0-29.258-23.803-53.061-53.061-53.061-29.259 0-53.063 23.803-53.063 53.061v38.063c0 8.284 6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.061 244.245h130.262c29.258 0 53.061-23.804 53.061-53.063 0-29.257-23.803-53.06-53.061-53.06h-130.262c-29.258.001-53.061 23.804-53.061 53.061 0 29.258 23.803 53.062 53.061 53.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.322 106.122h38.061c8.284 0 15-6.716 15-15v-38.061c0-29.258-23.803-53.061-53.061-53.061s-53.061 23.803-53.061 53.061 23.803 53.061 53.061 53.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.182 275.614c-29.258 0-53.061 23.804-53.061 53.063v130.261c0 29.259 23.803 53.063 53.061 53.063 29.26 0 53.064-23.804 53.064-53.063v-130.261c0-29.259-23.805-53.063-53.064-53.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.123 275.614h-38.062c-29.258 0-53.061 23.804-53.061 53.063 0 29.258 23.803 53.061 53.061 53.061 29.259 0 53.063-23.803 53.063-53.061v-38.063c-.001-8.284-6.717-15-15.001-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.939 267.753h-130.261c-29.258 0-53.061 23.804-53.061 53.063 0 29.257 23.803 53.06 53.061 53.06h130.262c29.258 0 53.061-23.803 53.061-53.06-.001-29.259-23.804-53.063-53.062-53.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.678 405.876h-38.061c-8.284 0-15 6.716-15 15v38.062c0 29.259 23.803 53.063 53.061 53.063 29.259 0 53.063-23.804 53.063-53.063-.001-29.258-23.804-53.062-53.063-53.062z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.ecebd73e.svg";
export { ForwardRef as ReactComponent };